import FindAddress from 'edge/platform/widgets/findaddress/components/FindAddress';
import 'edge/addresslookup/app';

export default angular.module('edge.platform.widgets.findaddress', ['edge.addresslookup.app'])
    .component('gwPlFindAddress', FindAddress);